export default __webpack_public_path__ + "static/deckoftux-0e7dcd3c71dfdad993faba6cd5998053.png";